<template>
  <section v-if="products.length > 0" class="section">
    <div class="container-lg">
      <div class="section__header">
        <h2 class="section__title">{{ in18['page_recommended_product'] }}</h2>
      </div>
      <div v-if="products.length > 1" class="row slider-no-dots" data-mobile-slider-arrows>
          <div v-for="product in products" class="col-md-3">
            <product-item :product="product"></product-item>
          </div><!-- /.col -->
      </div><!-- /.row -->
      <div v-else class="row">
        <div v-for="product in products" :key="product.id" class="col-md-3">
          <product-item :product="product"></product-item>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </section>
</template>

<script>
export default {
  name:  "RecommendedProductsManual",
  props: [
    'products',
    'in18',
  ],
}
</script>
